<div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 animate-fade-in-up">
  <!-- Top Action Bar -->
  <div class="w-full flex justify-between items-center mb-6">
    <app-btn-back routeTo="/profile/details" icon="fa fa-arrow-left" btnText="Back to Profile"></app-btn-back>
  </div>

  <!-- Settings List Container -->
  <div class="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
    <!-- Header -->
    <div class="p-6 border-b border-gray-100 flex items-center justify-between">
      <div>
        <h3 class="text-xl font-bold text-gray-900">Account Settings</h3>
        <p class="text-xs text-gray-500 mt-1">Manage your security preferences and application settings.</p>
      </div>
      <span class="text-xs font-bold uppercase tracking-wider bg-blue-50 text-secondary-600 px-3 py-1 rounded-full">
        Settings
      </span>
    </div>

    <!-- Settings List -->
    <div class="divide-y divide-gray-100">
      <!-- Setting 1: Change Password -->
      <div class="p-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 hover:bg-gray-50/50 transition-colors">
        <div class="flex items-center gap-4">
          <div class="w-12 h-12 rounded-2xl bg-primary-50 text-primary-500 flex items-center justify-center text-xl flex-shrink-0">
            <i class="fas fa-key"></i>
          </div>
          <div>
            <h4 class="text-base font-bold text-gray-900">Change Password</h4>
            <p class="text-xs text-gray-500 mt-0.5">Update your password to keep your account secure.</p>
          </div>
        </div>
        <button
          type="button"
          (click)="openChangePasswordDialog()"
          class="px-5 py-2.5 bg-primary-500 hover:bg-primary-600 text-white font-bold text-xs uppercase rounded-xl shadow-sm hover:shadow transition-all flex items-center gap-2 cursor-pointer whitespace-nowrap self-stretch sm:self-auto justify-center"
        >
          <i class="fas fa-lock text-xs"></i>
          Change Password
        </button>
      </div>

      <!-- Setting 2: Language Preference (Placeholder) -->
      <div class="p-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 hover:bg-gray-50/50 transition-colors opacity-75">
        <div class="flex items-center gap-4">
          <div class="w-12 h-12 rounded-2xl bg-gray-100 text-gray-500 flex items-center justify-center text-xl flex-shrink-0">
            <i class="fas fa-globe"></i>
          </div>
          <div>
            <div class="flex items-center gap-2">
              <h4 class="text-base font-bold text-gray-900">Language</h4>
              <span class="text-[10px] bg-gray-100 text-gray-500 px-2 py-0.5 rounded font-semibold uppercase">Coming Soon</span>
            </div>
            <p class="text-xs text-gray-500 mt-0.5">System display language (Default: English).</p>
          </div>
        </div>
        <button
          type="button"
          disabled
          class="px-5 py-2.5 bg-gray-100 text-gray-400 font-bold text-xs uppercase rounded-xl cursor-not-allowed whitespace-nowrap self-stretch sm:self-auto justify-center"
        >
          English
        </button>
      </div>

      <!-- Setting 3: Notification Preferences (Placeholder) -->
      <div class="p-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 hover:bg-gray-50/50 transition-colors opacity-75">
        <div class="flex items-center gap-4">
          <div class="w-12 h-12 rounded-2xl bg-gray-100 text-gray-500 flex items-center justify-center text-xl flex-shrink-0">
            <i class="fas fa-bell"></i>
          </div>
          <div>
            <div class="flex items-center gap-2">
              <h4 class="text-base font-bold text-gray-900">Notifications</h4>
              <span class="text-[10px] bg-gray-100 text-gray-500 px-2 py-0.5 rounded font-semibold uppercase">Coming Soon</span>
            </div>
            <p class="text-xs text-gray-500 mt-0.5">Manage email and push notification preferences.</p>
          </div>
        </div>
        <button
          type="button"
          disabled
          class="px-5 py-2.5 bg-gray-100 text-gray-400 font-bold text-xs uppercase rounded-xl cursor-not-allowed whitespace-nowrap self-stretch sm:self-auto justify-center"
        >
          Manage
        </button>
      </div>
    </div>
  </div>
</div>
